<script>
export default {
  props: ['stableData'],
  computed: {
    p_level () {
      if (this.stableData && this.stableData.p_pha > 1000 && this.stableData.p_phb > 1000 && this.stableData.p_phc > 1000) {
        return true
      } else {
        return false
      }
    },
    q_level () {
      if (this.stableData && this.stableData.q_pha > 1000 && this.stableData.q_phb > 1000 && this.stableData.q_phc > 1000) {
        return true
      } else {
        return false
      }
    },
    s_level () {
      if (this.stableData && this.stableData.s_pha > 1000 && this.stableData.s_phb > 1000 && this.stableData.s_phc > 1000) {
        return true
      } else {
        return false
      }
    },
    qf_level () {
      if (this.stableData && this.stableData.qf_pha > 1000 && this.stableData.qf_phb > 1000 && this.stableData.qf_phc > 1000) {
        return true
      } else {
        return false
      }
    },
    qh_level () {
      if (this.stableData && this.stableData.qh_pha > 1000 && this.stableData.qh_phb > 1000 && this.stableData.qh_phc > 1000) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<template>
  <div class="pg">
    <!--      功率-->
    <div class="dataItems">
      <div class="title">三相功率</div>
      <div class="dataItem">
        <div class="dataName">
          <div class="dataTitle">功率</div>
          <div class="dataNvItem">{{ p_level ? 'P(MW)' : 'P(kW)' }}</div>
          <div class="dataNvItem">{{ q_level ? 'Q(MVar)' : 'Q(kVar)' }}</div>
          <div class="dataNvItem">{{ s_level ? 'S(MVA)' : 'S(kVA)' }}</div>
          <div class="dataNvItem">{{ qf_level ? 'QF(MVar)' : 'QF(kVar)' }}</div>
          <div class="dataNvItem">{{ qh_level ? 'QH(MVar)' : 'QH(kVar)' }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">A相</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.p_pha : 0) / (p_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.q_pha : 0) / (q_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.s_pha : 0) / (s_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qf_pha : 0) / (qf_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qh_pha : 0) / (qh_level ? 1000 : 1)).toFixed(2)}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">B相</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.p_phb : 0) / (p_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.q_phb : 0) / (q_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.s_phb : 0) / (s_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qf_phb : 0) / (qf_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qh_phb : 0) / (qh_level ? 1000 : 1)).toFixed(2)}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">C相</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.p_phc : 0) / (p_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.q_phc : 0) / (q_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.s_phc : 0) / (s_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qf_phc : 0) / (qf_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qh_phc : 0) / (qh_level ? 1000 : 1)).toFixed(2)}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">总</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.p_total : 0) / (p_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.q_total : 0) / (q_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.s_total : 0) / (s_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qf_total : 0) / (qf_level ? 1000 : 1)).toFixed(2)}}</div>
          <div class="dataNvItem">{{(Number(stableData ? stableData.qh_total : 0) / (qh_level ? 1000 : 1)).toFixed(2)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.dataValue {
  width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/Power/Power.vue